<template>
  <div class="appVersionList">
    <el-card>
      <el-button type="primary" slot="header" size="medium" @click="jump()">{{$t('lang.btn_AddApp')}}</el-button>
      <el-table :data="appList"  class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange" :height="appList.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="55px"
        ></el-table-column>
        <el-table-column prop="versionCode" sortable :label="$t('lang.lab_versionCode')" width="130px">
        </el-table-column>
        <el-table-column :label="$t('lang.lab_appId')" width="80px">
          <template slot-scope="scope">
            <span v-if="scope.row.appId == 1">
              {{$t('lang.lab_user')}}
            </span>
            <span v-if="scope.row.appId != 1">
              {{$t('lang.lab_VIPuser')}}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_appAreaValue')" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.platform == 1">
              android
            </span>
            <span v-if="scope.row.platform != 1">
              ios
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_upgradeLevel')" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.upgradeLevel == 0">
              {{$t('lang.lab_noUpdate')}}
            </span>
            <span v-if="scope.row.upgradeLevel == 1">
              {{$t('lang.lab_normalUpdate')}}
            </span>
            <span v-if="scope.row.upgradeLevel == 2">
              {{$t('lang.lab_recommendUpdate')}}
            </span>
            <span v-if="scope.row.upgradeLevel != 0 && scope.row.upgradeLevel != 1 && scope.row.upgradeLevel != 2">
              {{$t('lang.lab_mustUpdate')}}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.key_versionName')" sortable prop="versionName" width="160px" class="text-middle">
        </el-table-column>
        <el-table-column prop="uri" :label="$t('lang.lab_uri')" width="250px">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.uri&&scope.row.uri.length> require('@/config/enum').tableDatamaxlength25"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.uri }}
                </span>
              </div>
              <div>
                {{ scope.row.uri.substring(0, require('@/config/enum').tableDatamaxlength25) | valueIsNull }}
                <span
                  v-if="scope.row.uri.length>require('@/config/enum').tableDatamaxlength25"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.uri | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="title" :label="$t('lang.key_title')" width="320px">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.title&&scope.row.title.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.title }}
                </span>
              </div>
              <div>
                {{ scope.row.title.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span
                  v-if="scope.row.title.length>require('@/config/enum').tableDatamaxlength"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.title | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="content" :label="$t('lang.key_content')" width="330px">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.content&&scope.row.content.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.content }}
                </span>
              </div>
              <div>
                {{ scope.row.content.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span
                  v-if="scope.row.content.length>require('@/config/enum').tableDatamaxlength"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.content | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width1">
          <template slot-scope="scope"  align="center">
            <el-button class="orange" @click="delete1(scope.row.versionCode)">{{deletename}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
        />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:APPVersion
 *@Description:APP版本管理
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-02-21
 */
export default {
  data () {
    return {
      pageCount: 0, // 一共页数
      pageNum: 1, // 页码
      pageSize: 10, // 每页显示
      appList: [], // 列表
      multipleSelection: [], // 多选框
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
      deletename: require('@/config/enum').deletename // 删除
    }
  },
  created() {
    setTimeout(() => {
      window.localStorage.setItem('appbbform', '')
    }, 200)
    this.list()
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // APP管理列表
    list() {
      let loading = this.$loading()
      this.$get(
        `/version/page?pageSize=${this.pageSize}&pageNo=${this.pageNum}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.appList = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 点击换页
    handleCurrentChange(val) {
      this.pageNum = val
      this.list()
    },
    // 点击更改每页容量
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.list()
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 提交
    commit() {
      this.pageNum = 1
      this.list()
    },
    // 翻页
    jump() {
      this.$router.push({ name: 'addAppVersion' })
    },
    // 删除
    delete1(versionCode) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
        let params = {
          id: versionCode
        }
        this.$post(`/versionDel`, params).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message({
                type: 'success',
                message: this.$i18n.t('lang.lab_del_success')
              })
              this.commit()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      })
      .catch(() => {
        loading.close()
        this.$message({
          type: 'info',
          message: this.$i18n.t('lang.lab_del_can')
        })
      })
    }
  }
}
</script>

<style lang="scss">
  .el-tooltip__popper.is-light {
    max-width: 300px;
  }
</style>